export class SubCompanyChecklistsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getChecklistResults({ subCompanyId, checklistId, includeItems = true }) {
    return this.#http.get(`/api/sub-companies/${subCompanyId}/checklist-result`, {
      params: { checklistId, includeItems },
    });
  }

  // FH-1931/FH-1835: the flat-store lean read — same query params as `getChecklistResults` above,
  // returning the denormalized `FlatChecklistResult[]` tree instead of `ChecklistResultModel[]`.
  async getFlatChecklistResults({ subCompanyId, checklistId, includeItems = true }) {
    return this.#http.get(`/api/sub-companies/${subCompanyId}/checklist-result/v2`, {
      params: { checklistId, includeItems },
    });
  }

  async recomputeChecklistResults({ subCompanyId }) {
    return this.#http.post(`/api/sub-companies/${subCompanyId}/checklist-result/recompute`);
  }

  async setChecklistResultOverrides({ subCompanyId, itemsToOverride, itemsToRemoveOverride }) {
    return this.#http.post(`/api/sub-companies/${subCompanyId}/checklist-result/overrides`, {
      itemsToOverride,
      itemsToRemoveOverride,
    });
  }
}
